var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.menu, function (level1Item, level1Index) {
      return level1Item.name &&
        _vm.requireRole(level1Item) &&
        _vm.checkFlags(level1Item) &&
        !level1Item.hidden
        ? _c(
            "nav-menu-item",
            { key: level1Index, attrs: { "menu-item": level1Item } },
            [
              level1Item.subItems
                ? _vm._l(
                    level1Item.subItems,
                    function (level2Item, level2Index) {
                      return _vm.requireRole(level2Item) &&
                        _vm.checkFlags(level2Item)
                        ? _c(
                            "nav-menu-item",
                            {
                              key: level2Index,
                              attrs: {
                                "menu-item": level2Item,
                                subgroup: "",
                                small: "",
                                sinIcono: true,
                              },
                            },
                            [
                              level2Item.subItems
                                ? _vm._l(
                                    level2Item.subItems,
                                    function (level3Item, level3Index) {
                                      return _vm.requireRole(level3Item)
                                        ? _c("nav-menu-item", {
                                            key: level3Index,
                                            attrs: {
                                              "menu-item": level3Item,
                                              small: "",
                                              sinIcono: true,
                                            },
                                          })
                                        : _vm._e()
                                    }
                                  )
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e()
                    }
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e()
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }